<!--/*
 * Copyright (c) 2020 The Awareness Company. All rights reserved. 
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */ -->
<template>
  <apexchart type="line" height="310" :options="chartOptions" :series="series" />
</template>

<script>
export default {
  name: "Cases",
  data: () => ({
    series: [
      {
        name: "series1",
        data: []
      }
    ],
    chartOptions: {
      theme: {
        mode: "dark",
        palette: "palette10"
      },
      colors: ["#008FFB", "#4CAF50", "#e91e63", "#F86624"],
      chart: {
        background: "rgb(28, 42, 82)",
        foreColor: "rgb(212, 212, 212)",
        toolbar: {
          show: true,
          tools: {
            download: false,
            selection: false
          },
          autoSelected: "zoom"
        }
      },
      grid: {
        borderColor: "rgb(27, 36, 77)"
      },
      legend: {
        show: true,
        position: "bottom",
        itemMargin: {
          vertical: 10
        }
      },
      markers: {
        size: 0
      },
      stroke: {
          curve: 'smooth'
        },
      xaxis: {
        type: "datetime",
        labels: {
          style: {
            fontSize: "10px"
          }
        }
      },
      tooltip: {
        x: {
          show: true,
          format: "dd MMM"
        }
      }
    }
  }),
  methods: {
    loadCases(data, countryDisplay) {
      this.series[0].data = [];

      //first loop through each country and concat the cases data to find the distinct dates
      var allcases = []
      for (var i = 0; i < data.length; i++) {
        allcases = allcases.concat(data[i].cases)
      }

      //sort by date
      allcases = allcases.sort(function(a, b) {
        a = a.date;
        b = b.date;
        return a < b ? -1 : a > b ? 1 : 0;
      });

      //then get all the distinct dates
      var dates = [];
      dates = Array.from(new Set(allcases.map(cas => cas.date))).map(date => {
        return date;
      });

      //set the series
      var ser = [
        { name: "Confirmed", data: [] },
        // { name: "Recovered", data: [] },
        { name: "Deaths", data: [] },
        // { name: "Active", data: [] }
      ];

      //loop through all the dates and find cases
      for (var i = 0; i < dates.length; i++) {
        var thisDate = dates[i];

         //filter the matching dates from all cases
        var cdat = allcases.filter(c => c.date === thisDate)

        //CONFIRMED
        var confirmed = cdat.reduce(function(prev, cur) {
          return prev + cur.cumulative_cases;
        }, 0);

        //push to array
        ser[0].data.push([
          this.$moment(thisDate, "YYYY-MM-DD")
            .add(10, "hours")
            .toDate(),
          confirmed
        ]);

        // //RECOVERED
        // var recovered = cdat.reduce(function(prev, cur) {
        //   return prev + cur.cumulative_recovered;
        // }, 0);

        // //push to array
        // ser[1].data.push([
        //   this.$moment(thisDate, "YYYY-MM-DD")
        //     .add(10, "hours")
        //     .toDate(),
        //  recovered
        // ]);

        //DEATHS
        var deaths = cdat.reduce(function(prev, cur) {
          return prev + cur.cumulative_deaths;
        }, 0);

        //push to array
        ser[1].data.push([
          this.$moment(thisDate, "YYYY-MM-DD")
            .add(10, "hours")
            .toDate(),
          deaths
        ]);

        // //ACTIVE
        // var activeVal = confirmed - recovered - deaths;

        // //push to array
        // ser[3].data.push([
        //   this.$moment(thisDate, "YYYY-MM-DD")
        //     .add(10, "hours")
        //     .toDate(),
        //   activeVal
        // ]);
      }

      //set the graph data
      this.series = ser;
    },
    resize() {
      let self = this;
      this.$nextTick().then(function() {
        self.chartOptions = {
          chart: {
            height: "310"
          }
        };
      });
    }
  }
};
</script>
